export default __webpack_public_path__ + "static/media/pairdot-mobile-friendly-min.b8012590.png";